<template>
  <div class="card trips-tab">
    <BaseActionHeader title="Рейсы заказа">
      <base-primary-button
        icon="addSquare"
        @click="$emit('create-trip')"
        type="button"
      >
        Создать
      </base-primary-button>
    </BaseActionHeader>

    <TripSelect
      v-model="selectedTripId"
      placeholder="Добавить существующий рейс"
      class="trip-select"
      @change="addExistingTrip"
    />

    <!-- Список рейсов -->
    <ul class="trip-list" v-if="trips.length > 0">
      <li
        class="trip-item"
        v-for="trip in trips"
        :key="trip.id"
        @click="$emit('go-to-trip-details', trip.id)"
      >
        <div class="trip-info">
          <h4 class="trip-name">
            {{ trip.name || `Рейс #${trip.id}` }}
          </h4>
          <span class="trip-status">
            {{ trip.status }}
          </span>
        </div>
        <base-button
          type="button"
          @click.stop="removeTrip(trip.id)"
          class="delete-btn"
        >
          Отвязать
        </base-button>
      </li>
    </ul>

    <div v-else class="no-trips">
      <div class="no-trips-icon">🚚</div>
      <h4 class="no-trips-title">Привязанные рейсы отсутствуют</h4>
      <p class="no-trips-desc">
        Создайте первый рейс для этого заказа или добавьте
        существующий
      </p>
    </div>
  </div>
</template>

<script>
import TripSelect from "@/components/Trip/TripSelect.vue";

export default {
  name: "OrderTripsList",

  components: {
    TripSelect,
  },

  props: {
    trips: {
      type: Array,
      default: () => [],
    },
    orderId: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      selectedTripId: null,
    };
  },

  methods: {
    addExistingTrip(tripId) {
      if (!tripId) return;
      this.$emit("add-trip", tripId);
      this.$nextTick(() => {
        this.selectedTripId = null;
      });
    },

    removeTrip(tripId) {
      this.$emit("remove-trip", tripId);
    },
  },
};
</script>

<style scoped>
.trips-tab {
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.trip-select {
  margin-bottom: var(--base-in-indent);
}

.trip-list {
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.trip-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px;
  background: rgb(240, 240, 240);
  border-radius: 8px;
  transition: all 0.3s ease;
  cursor: pointer;
}

.trip-item:hover {
  background: #e6f5ed;
  transform: translateX(4px);
}

.trip-info {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.trip-name {
  font-weight: 600;
}

.trip-status {
  font-size: 13px;
  font-weight: 500;
}

.delete-btn {
  margin-left: 15px;
  flex-shrink: 0;
  background-color: #fff !important;
  border: 1px solid var(--color-danger) !important;
  color: var(--color-danger) !important;
}

.delete-btn:hover {
  background-color: var(--color-danger) !important;
  color: #fff !important;
}

.no-trips {
  text-align: center;
  padding: 50px 25px;
  color: #666;
}

.no-trips-icon {
  font-size: 48px;
  margin-bottom: var(--base-in-indent);
}

.no-trips-title {
  margin-bottom: 15px;
}

.no-trips-desc {
  margin-bottom: var(--base-out-indent);
  font-style: italic;
}

@media (max-width: 768px) {
  .trip-item {
    flex-direction: column;
    gap: 10px;
    align-items: stretch;
  }

  .delete-btn {
    margin-left: 0;
    align-self: flex-end;
  }
}
</style>
